import { SetBrandStyles } from '~/constants/actions';
import { SetBrandStyles as SetBrandStylesMutation, SetRemixImage } from '~/constants/mutations';
import { GetBrandStyles, GetRemixImage } from '~/constants/getters';

const defaultState = () => {
  return {
    brandStyles: [],
    remixImage: null,
  };
};

const state = defaultState();

const mutations = {
  [SetBrandStylesMutation](state, brandStyles) {
    state.brandStyles = brandStyles;
  },
  [SetRemixImage](state, remixImage) {
    state.remixImage = remixImage;
  },
};

const actions = {
  [SetBrandStyles]({ commit }, brandStyles) {
    commit(SetBrandStylesMutation, brandStyles);
  },
  [SetRemixImage]({ commit }, remixImage) {
    commit(SetRemixImage, remixImage);
  },
};

const getters = {
  [GetBrandStyles](state) {
    return state.brandStyles;
  },
  [GetRemixImage](state) {
    return state.remixImage;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
